import { IonApp, 
    IonHeader, 
    IonToolbar, 
    IonTitle, 
    IonContent, 
    IonFooter, 
    IonMenu,
    IonList,
    IonListHeader,
    IonSelect,
    IonSelectOption,
    IonAccordion, 
    IonRow,
    IonGrid,
    IonModal,
    IonCol,
    IonAccordionGroup,
    IonMenuToggle,
    IonIcon,
    IonLabel,
    IonPage ,
    IonButtons,
    IonButton,
    IonItem } from '@ionic/react';

    import React, { useState } from 'react';



function BottomNavComponent (props){
  
  const [isOpen, setIsOpen] = useState(false);

    return (
        <>
  
              <IonGrid>
                <IonRow>
                { props.showBackButton &&
                  <IonCol className="ion-align-self-end right bottom-nav">
                      <IonButton className='secondary' color="secondary" size="default"  mode='ios'  onClick={props.displayLogic}>Back</IonButton> {}
                  </IonCol>
                }
                <IonCol className="ion-align-self-end right bottom-nav">
                    <IonButton color="primary" size="default"  mode='ios'  onClick={props.displayLogic} disabled={props.showNextButton}>Next</IonButton> 
                </IonCol>
                </IonRow>
                </IonGrid>
  

        </>
    )
}

export default BottomNavComponent;